import React from 'react'
import AdmBookTitleReport from '../../components/AdminTabs/AdminBookTitleReport/AdmBookTitleReport'

const BookTitleReport = () => {
  return (
    <div>
        <AdmBookTitleReport/>
    </div>
  )
}

export default BookTitleReport